const { REACT_APP_ENV } = process.env;

export default ({ lat, lng, label = '' }, origin) => {
  if (REACT_APP_ENV === 'dev' || REACT_APP_ENV === 'stg') {
    const validGeolocationOrigins = [
      'currentStore',
      'user',
      'property',
      'countryDefault',
      'queryString',
    ];
    const hasAValidOrigin = validGeolocationOrigins.indexOf(origin) > -1;
    if (!hasAValidOrigin) {
      // eslint-disable-next-line no-console
      console.warn(
        `Invalid geolocation origin given. Origin should match one of the followings: ${validGeolocationOrigins.join(', ')}.`,
      );
    }
  }

  return {
    lat: parseFloat(lat),
    lng: parseFloat(lng),
    label,
    origin,
  };
};
